import { render, staticRenderFns } from "./ServiceGroupNew.vue?vue&type=template&id=dcb03da4&scoped=true&"
import script from "./ServiceGroupNew.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupNew.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroupNew.vue?vue&type=style&index=0&id=dcb03da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb03da4",
  null
  
)

export default component.exports